import type { Branch } from '../lib/api';

/**
 * Branch selector for cashier-area pages. Hidden for a scoped cashier (pinned
 * to their own branch); a dropdown for admin / super_admin.
 */
export function BranchPicker({
  branches,
  branchId,
  isScoped,
  onChange,
}: {
  branches: Branch[];
  branchId: string | null;
  isScoped: boolean;
  onChange: (id: string) => void;
}) {
  if (isScoped || branches.length <= 1) return null;
  return (
    <div className="flex items-center gap-2">
      <label className="text-xs text-muted-foreground">Branch</label>
      <select
        className="h-10 rounded-md border border-input bg-background px-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        value={branchId ?? ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {branches.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name} ({b.code})
          </option>
        ))}
      </select>
    </div>
  );
}
